export default "__VITE_ASSET__DpaqtSjq__"